import React from 'react';
import TextField from '@mui/material/TextField';

export default function AppDateField({
  helperText = 'DD/MM/YYYY',
  InputLabelProps,
  inputProps,
  FormHelperTextProps,
  ...props
}) {
  return (
    <TextField
      {...props}
      type="date"
      helperText={helperText}
      InputLabelProps={{ shrink: true, ...(InputLabelProps || {}) }}
      inputProps={{ lang: 'en-GB', ...(inputProps || {}) }}
      FormHelperTextProps={{ sx: { mt: 0.5 }, ...(FormHelperTextProps || {}) }}
    />
  );
}
